module.exports = __webpack_public_path__ + "static/img/card5.47684992.png";